import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import Button from "../../../shared/components/Button/Button";

import HospitalProfile from "../HospitalProfile/HospitalProfile";
import DoctorAppointments from "../DoctorAppointments/DoctorAppointments";
import PatientExpenseReport from "../PatientExpenseReport/PatientExpenseReport";
import PatientDetailsRecord from "../PatientDetailsRecord/PatientDetailsrecord";
import Backicon from "../../../shared/components/Backicon/Backicon";
import hospitalstyles from "./hospitalregister.module.css";
import HospitalAccess from "../HospitalAccess/HospitalAccess";

const initialState = {
  Name: "",
  Email: "",
  Address: "",
  Password: "",
  NameError: "",
  EmailError: "",
  AddressError: "",
  PasswordError: "",
  isLogin: true,
};

class HospitalRegister extends Component {
  state = initialState;

  change = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  validate = () => {
    let NameError = "";
    let EmailError = "";
    let AddressError = "";
    let PasswordError = "";
    //Name Error
    if (!this.state.Name) {
      NameError = "Invalid Name";
    }

    //Email Error
    if (!this.state.Email.includes("@")) {
      EmailError = "Invalid Email";
    }
    //Address Error
    if (!this.state.Address) {
      AddressError = "Address Cannot Be Empty";
    }
    // Password Error
    if (this.state.Password.length < 8) {
      PasswordError = "Need a strong Password";
    }

    if (EmailError || NameError || AddressError || PasswordError) {
      this.setState({ EmailError, NameError, AddressError, PasswordError });
      return false;
    }
    return true;
  };

  onSubmit = (e) => {
    e.preventDefault();
    const isValid = this.validate();
    if (isValid) {
      console.log(this.state);

      const hospital_register = {
        Name: this.state.Name,
        Email: this.state.Email,
        Address: this.state.Address,
        Password: this.state.Password,
      };
      localStorage.setItem(
        "hospital_login_signup",
        JSON.stringify(hospital_register)
      );

      //clear form
      this.setState(initialState);
    }
    this.props.history.push("/hospital/hospital-profile");
  };

  render() {
    return (
      <>
        <div className={hospitalstyles.content}>
          <div className={hospitalstyles.pregbanner}>
            <Backicon onClick={() => this.props.history.goBack()} />
            <h1>
              hospital <br /> register
            </h1>
          </div>
          <div className={hospitalstyles.signInStyles}>
            <div>
              <div className={hospitalstyles.regbuttons}>
                <button onClick={() => this.setState({ isLogin: true })}>
                  Login
                </button>
                <button onClick={() => this.setState({ isLogin: false })}>
                  Sign Up{" "}
                </button>
              </div>
              <form className={hospitalstyles.signupbtn}>
                {!this.state.isLogin && (
                  <>
                    <input
                      name="Name"
                      placeholder={"Name"}
                      value={this.state.name}
                      onChange={(e) => this.change(e)}
                    />
                    {this.state.NameError ? (
                      <div className={hospitalstyles.error}>
                        {this.state.NameError}
                      </div>
                    ) : null}
                    <br />
                  </>
                )}

                <input
                  name="Email"
                  placeholder="Email"
                  value={this.state.Email}
                  onChange={(e) => this.change(e)}
                />
                {this.state.EmailError ? (
                  <div className={hospitalstyles.error}>
                    {this.state.EmailError}
                  </div>
                ) : null}
                <br />

                {!this.state.isLogin && (
                  <>
                    <textarea
                      name="Address"
                      placeholder="Address"
                      value={this.state.Address}
                      onChange={(e) => this.change(e)}
                    />
                    {this.state.AddressError ? (
                      <div className={hospitalstyles.error}>
                        {this.state.AddressError}
                      </div>
                    ) : null}
                    <br />
                  </>
                )}

                <input
                  name="Password"
                  type="password"
                  placeholder="Password"
                  value={this.state.Password}
                  onChange={(e) => this.change(e)}
                />
                {this.state.PasswordError ? (
                  <div className={hospitalstyles.error}>
                    {this.state.PasswordError}
                  </div>
                ) : null}
                <div className={hospitalstyles.submitButton}>
                  <Button
                    onClick={(e) => this.onSubmit(e)}
                    buttonName={this.state.isLogin ? "Log in" : "sign up"}
                    style={{
                      color: "white",
                      width: "260px",
                      margin: "20px 30px",
                    }}
                  ></Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </>
    );
  }
}

function HospitalRoutes() {
  return (
    <Switch>
      <Route path="/hospital" exact component={HospitalRegister} />
      <Route
        path="/hospital/hospital-profile"
        exact
        component={HospitalProfile}
      />
      <Route
        path="/hospital/doctor-appointments"
        component={DoctorAppointments}
      />
      <Route
        path="/hospital/patients-expense-report"
        component={PatientExpenseReport}
      />
      <Route
        path="/hospital/patient-details-record"
        component={PatientDetailsRecord}
      />
      <Route
        path="/hospital/hospital-access"
        component={HospitalAccess}
      />
    </Switch>
  );
}

export default HospitalRoutes;
